import { Plan } from '../../../../../../types/CompanyPaymentDto';
import * as R from '../../../../../routes';
import { getCycleLimit } from '../../../../services/ReviewCycles';
import { interpolateAppUrl } from '../../../../services/Url';
import Link from '../../../Link';

function getUpgradeLink() {
    return interpolateAppUrl(R.SETTINGS_CHECKOUT, {});
}

const REVIEW_CYCLE_OVERALL_RATING_PARSE_EXCEPTION = () => (
    <div>
        <h1>Overall ratings unsupported</h1>
        You tried to create a cycle with an unsupported overall ratings configuration. We will investigate the issue,
        but it would help us if you could take a screenshot of your configuration. You can send it to{' '}
        <a href="mailto:support@small-improvements.com">support@small-improvements.com</a>.
    </div>
);

const PLAN_CYCLE_LIMIT_REACHED = () => {
    return (
        <div>
            <h1>Cycle limit reached</h1>
            On your current plan, you can only create up to {getCycleLimit(Plan.Launch)} cycles per year.
            <br />
            <Link href={getUpgradeLink()}>See Upgrade Options</Link>
        </div>
    );
};

const FEEDBACK_PARTICIPANT_INACTIVE = () => (
    <div>
        <h1>Failed to add user</h1>
        You tried to add an inactive reviewee to the cycle.
    </div>
);

const FEEDBACK_CYCLE_NOT_CURRENTLY_MATCHING = () => (
    <div>
        <h1>Cycle creation failed</h1>
        The cycle is currently not in progress. Either it has not yet started or it is already over.
    </div>
);

export default {
    REVIEW_CYCLE_OVERALL_RATING_PARSE_EXCEPTION,
    PLAN_CYCLE_LIMIT_REACHED,
    FEEDBACK_PARTICIPANT_INACTIVE,
    FEEDBACK_CYCLE_NOT_CURRENTLY_MATCHING,
};
